import Resource from '@/api/resources/Resource'

class DiagnosisSubportionService extends Resource {
    async createSubportionRevision(laboratoryId, caseId, sampleId, portionId, subportionId, request) {
        const response = await this.axios.post(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/revisions`, request)
        return response.data
    }
}

export default new DiagnosisSubportionService()
